import { useRef, useState } from "react";
import { Loader2, Mic, Square } from "lucide-react";
import { toast } from "sonner";

// Hold the mic, let go, and MiLu writes it down. Used by walkers and by their friends.
export const VoiceNoteRecorder = ({ onSend, testid = "voice-note-record", label = "Record a voice note" }) => {
  const [recording, setRecording] = useState(false);
  const [sending, setSending] = useState(false);
  const recorder = useRef(null);
  const chunks = useRef([]);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const rec = new MediaRecorder(stream);
      chunks.current = [];
      rec.ondataavailable = (e) => e.data.size && chunks.current.push(e.data);
      rec.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        const blob = new Blob(chunks.current, { type: "audio/webm" });
        if (blob.size < 1200) return toast.error("That recording is too short");
        setSending(true);
        try {
          await onSend(blob);
        } finally {
          setSending(false);
        }
      };
      rec.start();
      recorder.current = rec;
      setRecording(true);
    } catch {
      toast.error("MiLu needs permission to use your microphone");
    }
  };

  const stop = () => {
    recorder.current?.stop();
    recorder.current = null;
    setRecording(false);
  };

  return (
    <button
      data-testid={testid}
      onClick={recording ? stop : start}
      disabled={sending}
      className={`inline-flex min-h-[36px] items-center gap-1.5 rounded-full px-4 text-xs font-semibold transition-colors active:scale-95 disabled:opacity-50 ${
        recording ? "bg-destructive text-white" : "bg-brand text-white hover:bg-brand-hover"}`}
    >
      {sending ? <Loader2 className="h-3.5 w-3.5 animate-spin" />
        : recording ? <Square className="h-3.5 w-3.5" />
        : <Mic className="h-3.5 w-3.5" />}
      {sending ? "Sending…" : recording ? "Stop and send" : label}
    </button>
  );
};
